import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="text-white bg-black">
      <div className="grid grid-cols-1 gap-10 px-10 py-12 mx-auto sm:grid-cols-2 md:grid-cols-5">
        {/* Brand */}
        <div>
          <h2 className="mb-4 text-3xl font-extrabold">
            <Link to="/" className="whitespace-nowrap">
              Practical InfoSec <br /> Pvt Ltd.
            </Link>
          </h2>

          <p className="text-gray-300 text-md">
            Practical Cybersecurity Learning Platform.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="mb-3 text-xl font-semibold">Quick Links</h3>

          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <Link to="/" className="hover:text-white hover:font-semibold">
                Home
              </Link>
            </li>

            <li>
              <a
                href="https://courses.practicalinfosec.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white hover:font-semibold"
              >
                Courses
              </a>
            </li>

            <li>
              <Link
                to="/blog"
                className="hover:text-white hover:font-semibold"
              >
                Blog
              </Link>
            </li>

            <li>
              <Link
                to="/about"
                className="hover:text-white hover:font-semibold"
              >
                About Us
              </Link>
            </li>

            <li>
              <Link
                to="/privacy-policy"
                className="hover:text-white hover:font-semibold"
              >
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="mb-3 text-xl font-semibold">Contact</h3>

          <ul className="space-y-2 text-sm text-gray-400">
            <li className="hover:text-white hover:font-semibold">
              <a href="tel:+919080432374">
                <i className="mr-2 fas fa-phone-alt"></i>
                +91-9080432374
              </a>
            </li>

            <li className="whitespace-nowrap hover:text-white hover:font-semibold">
              <a href="mailto:support@practicalinfosec.com">
                <i className="mr-2 fas fa-envelope"></i>
                support@practicalinfosec.com
              </a>
            </li>

            <li className="hover:text-white hover:font-semibold">
              <i className="mr-2 fas fa-map-marker-alt"></i>
              Hyderabad, India
            </li>
          </ul>
        </div>

        {/* Social */}
        <div>
          <h3 className="mb-3 text-lg font-semibold text-left">Follow Us</h3>

          <div className="flex space-x-4 text-2xl">
            <a
              href="https://x.com/Practicainfosec"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-sky-400"
              aria-label="Twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>

            <a
              href="https://www.youtube.com/@PracticalInfosec-Telugu/videos"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-red-600"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>

            <a
              href="https://www.instagram.com/practicalinfosec/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-pink-600"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>

            <a
              href="https://www.linkedin.com/company/practicalinfosec"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-500"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>

        {/* App Download */}
        <div>
          <h3 className="mb-3 text-lg font-semibold text-left">Get Our App</h3>

          <a
            href="https://play.google.com/store/apps/details?id=co.shield.jyrvp&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              className="h-12 transition-opacity duration-300 hover:opacity-80"
            />
          </a>
        </div>
      </div>

      {/* SEO Keywords */}
      <div className="px-4 py-4 mx-auto text-xl font-medium text-center text-gray-300 border-t border-gray-700">
        Cyber security course in Hyderabad | Cyber security course | Cyber
        security training | Cyber Security training courses | Cyber security
        training near me | Cyber security course online | Cyber security course
        fees | Online classes for cyber security | Cyber security certification
        course | Ethical hacking training Hyderabad | Ethical hacking course in
        Hyderabad | Best cyber security courses | VAPT online training |
        Cybersecurity training and certification | Cybersecurity job roles |
        Cybersecurity course duration
      </div>

      {/* Copyright */}
      <div className="py-6 text-sm text-center text-gray-400 border-t border-gray-700">
        All rights reserved. © 2025, Practical Infosec Pvt Ltd.
      </div>
    </footer>
  );
}

export default Footer;